import { SelectChangeEvent } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';

import { useQuerySupplies } from 'v2/resources/hooks/services/useGraphics';
import {
  useAppDispatch,
  useAppSelector,
} from 'v2/resources/hooks/useAppSelector';
import { IResponseSupply } from 'v2/resources/types/graphics';
import { setGraphicSupply } from 'v2/store/dataChat/slice';

const useSupplies = () => {
  const dispatch = useAppDispatch();
  const { selectedCycle } = useAppSelector((state) => state.selectedCycle);

  const [selectedInput, setSelectedInput] = useState('');

  const { data: dataSupplies } = useQuerySupplies(selectedCycle?.id);

  const loadSupplies = useCallback(() => {
    setSelectedInput(dataSupplies?.labels[0] ?? '');
    dispatch(setGraphicSupply(dataSupplies ?? ({} as IResponseSupply)));
  }, [dataSupplies]);

  const [selectedShrimpPond, setSelectedShrimpPond] = useState<
    Record<string, any>[]
  >([]);

  const handleSelectedInput = (event: SelectChangeEvent<unknown>) => {
    const { value } = event.target;
    if (value === 'default') {
      return;
    }
    setSelectedInput(value as string);
  };

  const onlyGraphicsAccordingInput = useMemo(() => {
    if (!dataSupplies) return [];

    const filtered = dataSupplies?.data.filter(
      (shrimpPond) => shrimpPond[selectedInput]
    );

    setSelectedShrimpPond(filtered);

    return filtered;
  }, [dataSupplies, selectedInput]);

  const dataKeyBar =
    dataSupplies?.labels?.find((label) => label === selectedInput) ??
    'Não encontrado';

  const optionsSupplies = [
    {
      id: 0,
      label: 'Insumos',
      value: 'default',
    },
    ...(dataSupplies?.labels.map((label, index) => ({
      id: index + 1,
      label: label,
      value: label,
    })) ?? [
      {
        id: 1,
        label: 'Sem opções',
        value: 'Sem opções  ',
      },
    ]),
  ];

  useEffect(() => {
    loadSupplies();
  }, [loadSupplies]);

  return {
    selectedInput: optionsSupplies.length === 1 ? 'default' : selectedInput,
    dataKeyBar,
    optionsSupplies,
    onlyGraphicsAccordingInput,
    selectedShrimpPond,
    setSelectedShrimpPond,
    handleSelectedInput,
  };
};

export default useSupplies;
